import { Box, SelectOptionGroups } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Select from 'modules/core/components/Select'
import i18n from 'modules/core/lib/i18n'

import TooltipIcon from 'modules/shift_management/components/ShiftManagement/TooltipIcon'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

interface Props {
  form: PlannedBreakForm
}

const BreakTypeSelector = ({ form }: Props) => {
  const breakTypeOptions: SelectOptionGroups = [
    {
      label: i18n.t('shift_management.saved_shifts.breaks_form.scheduling.flexible'),
      value: 'flexible',
    },
    {
      label: i18n.t('shift_management.saved_shifts.breaks_form.scheduling.semi_flexible'),
      value: 'semi_flexible',
    },
    {
      label: i18n.t('shift_management.saved_shifts.breaks_form.scheduling.fixed'),
      value: 'fixed',
    },
  ]

  return (
    <Box flexDirection="row" gap="s12" alignItems="center" width="full">
      <TooltipIcon.Medium
        icon="split"
        label={i18n.t('shift_management.saved_shifts.breaks_form.scheduling.title')}
        color="grey1000"
      />
      <Select
        value={form.get('break_type').value}
        onChange={(value) => {
          form.setValues({ break_type: value })
          form.resetErrors()
        }}
        options={breakTypeOptions}
        hideLabel
        label={i18n.t('shift_management.saved_shifts.breaks_form.scheduling.title')}
      />
    </Box>
  )
}

export default observer(BreakTypeSelector)
